<template>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="top-banner-box">
                <!-- <div class="map-legend map-classical-row-legend-flex">
                    <div class="d-flex flex-wrap p-4">
                        <div class="p-3" v-for="(legend, index) in mapLegends" :key="index">
                            <span
                                class="legend-circle"
                                :style="{ backgroundColor: legend.colour }"
                            ></span>
                            {{ legend.name }}
                        </div>
                    </div>
                </div> -->
                <BaseMap
                    v-if="showMap && mode === 'map'"
                    type="satellite"
                    class="h-full"
                    @map-loaded="onMapLoaded"
                />
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-7 col-xl-12 roman-map-classical-container">
            <div class="inner-box">
                <div class="inner-content">
                    <div class="banner-box">
                        <img class="rounded-4 h-400 img-row-feedback" :src="sampleGroup.main_image?.url" />
                    </div>
                    <h4 class="my-4"><b>{{ sampleGroup.heading }}</b></h4>

                    <!-- <div class="result-map-bar my-3 p-4">
                        <div class="row w-100">
                            <div class="col-2">
                                <p>Closest Sample</p>
                                <h4 class="d-flex text-start">3DT16</h4>
                            </div>
                            <div class="col-6">
                                <p>Location</p>
                                <h4 class="d-flex text-start">
                                    England, Yorkshire, Driffield Terrace, UK
                                </h4>
                            </div>
                            <div class="col-2">
                                <p>Time Zone</p>
                                <h4 class="d-flex text-start">200CE</h4>
                            </div>
                            <div class="col-2 d-flex align-items-center">
                                <button v-if="!hasZoomed" @click="zoom" class="load-btn m-auto">
                                    <FeatherWrapper icon="zoom-in" />
                                    <span>Zoom on Map</span>
                                </button>
                                <button v-else @click="resetZoom" class="load-btn m-auto">
                                    <FeatherWrapper icon="zoom-out" />
                                    <span>Reset</span>
                                </button>
                            </div>
                        </div>
                    </div> -->
                    <div class="sampleGroup" v-html="sampleGroup.text" />
                    <!-- <h6 class="mb-3"><b> Time range of Samples: 652 - 47 BCE </b></h6>
                    <p>
                        The age of the remains and their geographic location correspond to the
                        beginning of the Saite Period following the invasion of the Assyrians in 664
                        BCE. For more than a century the ruling Saite Kings conferred a level of
                        stability and unity to Egypt though its influence in the region was reduced.
                        The threat of invasion was never far away, and in 568 BCE Babylonia invaded
                        Egypt, but soon after Egypt and Babylonia formed an alliance in order to
                        repel the common threat of the Persian Empire to the east. However, both
                        were eventually conquered, marking the beginning of the Persian Period in
                        Egyptian history (525–404 BCE). A coalition of local Egyptian rulers were
                        able to overthrow their Persian masters in 404 BCE. In the following half a
                        century Egypt successfully repelled multiple Persian invasions until
                        eventual defeat in 343 BCE. Only 10 years later they too were defeated by
                        Alexander the Great in 332 BCE. The Macedonian Dynasty ruled Egypt until its
                        final annexation by Rome in 30 BCE.
                    </p> -->
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { inject, ref, defineProps } from "vue";
import BaseMap from "@/components/Maps/BaseMap.vue";
// import Sidebar from "@/components/Sidebar.vue";
import {
    attachClassicalShapesToMap,
    attachClassicalSitesToMap,
    zoomToGroup,
} from "@/view/ancestry/recent/mapHelpers";
// import MobileContent from "@/components/ancestry/MobileContent.vue";
// import ClosestSample from "@/components/Classical/ClosestSample.vue";
// import MapLegend from "@/components/MapLegend.vue";
//import { getClassicalColour } from "@/composables/useClassicalContent";

const props = defineProps({
    introduction: Object,
    sampleGroup: Object,
    sampleSites: Object,
});

const showMap = ref(false);
const mode = ref("map");
const mapRef = ref({});
// const hasZoomed = ref(false);
const result = inject("egyptian-result");
const closestSampleInfo = ref(null);

/* const mapLegends = [
    { name: "Closest sample site", colour: "hsl(141,96%,37%)", type: "site" },
    {
        name: `Other ${props?.sampleGroup?.heading} sites`,
        colour: getClassicalColour("egyptian"),
        type: "site",
    },
    {
        name: `${props?.sampleGroup?.heading} geographical area`,
        colour: getClassicalColour("egyptian"),
        type: "main-area",
    },
    {
        name: `Egyptian Empire`,
        colour: getClassicalColour("egyptian"),
        type: "area",
    },
    {
        name: `Other egyptian sites`,
        colour: "#ccc",
        type: "site",
    },
]; */

setTimeout(() => {
    showMap.value = true;
});
// function zoom() {
//     hasZoomed.value = true;
//     const [sampleGroupFeature] = JSON.parse(props?.sampleGroup?.plain_text).features;
//     zoomToGroup(mapRef.value, sampleGroupFeature);
// }

// function resetZoom() {
//     hasZoomed.value = false;
//     const [feature] = JSON.parse(props?.introduction?.plain_text).features;
//     zoomToGroup(mapRef.value, feature);
// }

function onMapLoaded(map) {
    mapRef.value = map;

    const sites = JSON.parse(props?.sampleSites?.plain_text).features;
    const [feature] = JSON.parse(props?.introduction?.plain_text).features;
    const [sampleGroupFeature] = JSON.parse(props?.sampleGroup?.plain_text).features;

    attachClassicalShapesToMap(map, {
        people: "egyptian",
        feature,
        type: "main",
    });

    attachClassicalShapesToMap(map, {
        people: "egyptian",
        feature: sampleGroupFeature,
        type: "sampleGroup",
    });

    zoomToGroup(map, feature);

    const siteInfo = attachClassicalSitesToMap(map, {
        sites,
        people: "egyptian",
        closestSample: result?.egyptians?.closest_sample,
    });

    closestSampleInfo.value = siteInfo.pop();
}
</script>
